import { GenericAbortSignal } from 'axios';

import { httpService } from '@shared/httpService';
import { LabelValue } from '@shared/models/LabelValue';

enum PunctualAvailabilitiesTimespan {
  DAY_ONLY = 'DAY_ONLY',
  NIGHT_ONLY = 'NIGHT_ONLY',
  DAY_AND_NIGHT = 'DAY_AND_NIGHT',
}

type UserAccountDTO = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  frontAppChatbotUserHash: string;
  phone: string;
  siretId: string | null;
  // TODO(@ThbltLmr): remove when we deprecate Fillout form
  punctualAvailabilitiesFormUrl: string;
  punctualAvailabilities: string[] | null;
  punctualAvailabilitiesTimespan: PunctualAvailabilitiesTimespan | null;
  acceptedJobs: LabelValue<string>[];
  diplomas: LabelValue<string>[];
  hasPendingUnsubscription: boolean;
  doesNotAcceptIndependentJobs: boolean;
  updateDocumentsFormUrl: string;
  missingRequiredDocuments: LabelValue<string>[] | null;
};

type UserAccount = {
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
  frontAppChatbotUserHash: string;
  acceptedJobs: LabelValue<string>[];
  diplomas: LabelValue<string>[];
  siretId: string | null;
  // TODO(@ThbltLmr): remove when we deprecate Fillout form
  punctualAvailabilitiesFormUrl: string;
  punctualAvailabilities: Date[] | null;
  punctualAvailabilitiesTimespan: PunctualAvailabilitiesTimespan | null;
  hasPendingUnsubscription: boolean;
  doesNotAcceptIndependentJobs: boolean;
  updateDocumentsFormUrl: string;
  missingRequiredDocuments: LabelValue<string>[] | null;
};

const mapUserAccountDTOToUserAccount = (dto: UserAccountDTO): UserAccount => {
  return {
    firstName: dto.firstName,
    lastName: dto.lastName,
    fullName: `${dto.firstName} ${dto.lastName}`,
    email: dto.email,
    frontAppChatbotUserHash: dto.frontAppChatbotUserHash,
    siretId: dto.siretId,
    // TODO(@ThbltLmr): remove when we deprecate Fillout form
    punctualAvailabilitiesFormUrl: dto.punctualAvailabilitiesFormUrl,
    punctualAvailabilities: !!dto.punctualAvailabilities
      ? dto.punctualAvailabilities.map((punctualAvailability) => new Date(punctualAvailability))
      : null,
    punctualAvailabilitiesTimespan: dto.punctualAvailabilitiesTimespan,
    acceptedJobs: dto.acceptedJobs,
    diplomas: dto.diplomas,
    hasPendingUnsubscription: dto.hasPendingUnsubscription,
    doesNotAcceptIndependentJobs: dto.doesNotAcceptIndependentJobs,
    updateDocumentsFormUrl: dto.updateDocumentsFormUrl,
    missingRequiredDocuments: dto.missingRequiredDocuments,
  };
};

const fetchUserAccount = async (signal: GenericAbortSignal) => {
  const url = `/account`;

  return httpService
    .get<UserAccountDTO>(url, { signal })
    .then((response) => mapUserAccountDTOToUserAccount(response.data));
};

export default fetchUserAccount;

export { PunctualAvailabilitiesTimespan, type UserAccount };
